<template>
  <b-modal
    centered
    hide-footer
    footer-class="border-top-none"
    header-class="border-bottom-none"
    id="modal-confirm"
    ref="modal-confirm"
    size="md"
    :title="title"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <div class="font-size-14">
      <div class="w-100 text-right">
        <b-button
          @click="confirm()"
          class="btn btn-red mr-2"
          :disabled="isLoading"
        >
          <font-awesome-icon icon="trash-alt" class="mr-1" /> Xóa
        </b-button>
        <b-button
          @click="hideModal()"
          class="btn btn-yellow"
          :disabled="isLoading"
        >
          <font-awesome-icon icon="sync" class="mr-1" />
          Hủy
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BO_QUA_BUTTON_LABEL,
  DONG_Y_BUTTON_LABEL,
} from "@/constants/constants";

export default {
  name: "ModalConfirmTitle",
  props: {
    title: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | null,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      DONG_Y_BUTTON_LABEL: DONG_Y_BUTTON_LABEL,
    };
  },
  methods: {
    hideModal() {
      this.$refs["modal-confirm"].hide();
    },
    confirm() {
      this.$emit("confirmed", true);
    },
    showModal() {
      this.$refs["modal-confirm"].show();
    },
  },
};
</script>

<style lang="scss">
#modal-confirm .modal-header {
  background: white;
  h5 {
    color: black;
  }

  .close {
    display: none;
  }
}
</style>
